<template>
  <div class="body-of-home">
    <div class="title-box">
      <h1 style="color: #FFF; text-align: center; margin-top: 66px;">DogMotics SELF h24</h1>
    </div>
    <div class="button-box">
      <b-container>
        <b-col>
          <div class="col align-self-center button" variant="primary" size="md" @click.prevent="onClickButton" style="max-width: 44%; padding: 10px;">
            <strong><h1>ENTRA</h1></strong>
          </div>
        </b-col>
      </b-container>
      
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
      onClickButton() {
        event.preventDefault()
        //this.$router.push({ name: 'welcome' })
        this.$router.push({ name: 'login' })
      }
    }
  };


</script>
<style>
.body {
  width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: fixed;
    background-image: url(../assets/home.jpg) !important;
    background-color:#ccc; 
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center 
}
.title-box {
  height: 70%;
  width: 80%px;  
}
.button-box {
  height: 25%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.button {
    max-width: 44% important!;
    color: #fff;
    border-radius: 20px;
    background-color: #bad000;
    padding: 10px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .button:hover {
    background-color: #777;
    cursor: pointer;
  }
</style>
/*<style>
  .body-of-home {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: fixed;
    background-image: url(../assets/home.jpg) !important;
    background-color:#ccc; 
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center
  }
  .caption {
    color: #fff;
    padding: 10px;
    margin: 30px 10px;
    text-align: center;
  }
  .buttonX {
    width: 250px;
    color: #fff;
    border-radius: 20px;
    background-color: #bad000;
    padding: 10px;
    bottom: 10%;
    text-align: center;
    position: absolute;
    left: 35%;
    right: 35%;
  }
  .button:hover {
    background-color: #777;
    cursor: pointer;
  }
</style>*/